<template>
  <form>
    <v-container fluid>
      <v-layout row wrap justify-center>
        <v-flex xs6 sm6>
          <slot />

          <v-layout row>
            <v-btn v-if="cancel"  class="elevation-0" error @click="cancelClick"><v-icon dark left>clear</v-icon> <span>{{ $t('cancel') }}</span></v-btn>
            <v-spacer />
            <v-btn v-if="save" class="elevation-0" success @click="saveClick"><v-icon dark left>save</v-icon> <span>{{ $t('save') }}</span></v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </form>
</template>

<script>
export default {
  props: {
    save: {
      type: Boolean,
      default: true
    },
    cancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    saveClick () {
      this.$emit('save')
    },
    cancelClick () {
      this.$emit('cancel')
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormContainer.vue?9f653058